/*  Copyright 2018, 2019 Sebastian Spautz

    This file is part of "AiS Online Forms".

    "AiS Online Forms" is free software: you can redistribute it and/or modify
    it under the terms of the GNU General Public License as published by
    the Free Software Foundation, either version 3 of the License, or
    any later version.
    This program is distributed in the hope that it will be useful,
    but WITHOUT ANY WARRANTY; without even the implied warranty of
    MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
    GNU General Public License for more details.
    You should have received a copy of the GNU General Public License
    along with this program.  If not, see http://www.gnu.org/licenses/.
*/

import localize from './localize.js'

/**
  * Modul to init and updates service worker.
  * @module acesinspace.pwa
*/

/**
 * Init the handling of PWA functionality.
 * 
 * Call it best inside a DOMContentLoaded event.
 * 
 * @private
 * @param {string} serviceworkerpath The path to the script for the service worker.
 * @returns {undefined}
 */
export default function initPWA (serviceworkerpath) {
    if (typeof navigator.serviceWorker !== 'undefined') {
        let installPrompt = null
        const installButton = document.getElementById('install-pwa')

        if (installButton) {
            window.addEventListener('beforeinstallprompt', (event) => {
                console.debug('before install prompt')
                event.preventDefault()
                installPrompt = event
                installButton.removeAttribute('hidden')
            })

            installButton.addEventListener('click', async () => {
                if (installPrompt) {
                    try {
                        result = await installPrompt.prompt()
                        console.log(`Install prompt was: ${result.outcome}`)
                    }
                    catch (error) {
                        console.debug(`Installation canceled or unexpected error occuered: ${error}`)
                    }
                }
                installPrompt = null
                installButton.setAttribute('hidden', '')
            })
        }

        window.addEventListener('load', (/* event */) => {
            console.debug('loaded (in PWA)')
            navigator.serviceWorker.register(serviceworkerpath)
            .then(serviceWorkerRegistration => {
                
                // on page load, if a service worker is active and a newer on is installed but not active now
                if (serviceWorkerRegistration.active) { // A version of the service worker is active
                    console.debug('At page load a service worker is active')
                    if (serviceWorkerRegistration.waiting) { // A newer Update is waiting to get updated
                        console.debug('At page load a newer version of the service worker is waiting to getting active.')
                        forceUpdate(serviceWorkerRegistration.waiting)
                    }
                }

                // if an update is installing but not active after page load
                serviceWorkerRegistration.addEventListener("updatefound", ( /*event*/ ) => {
                    console.debug('update found')
                    // listen to state changes on the updated service worker
                    serviceWorkerRegistration.installing?.addEventListener('statechange', (event) => {
                        console.debug('state changed to ' + event.target.state)
                        const STATE = event.target.state

                        // if the new state is waiting, means the installation is finished ask user to force update
                        if (serviceWorkerRegistration.active &&
                                STATE === 'installed') {
                            forceUpdate(serviceWorkerRegistration.waiting)
                        }
                    })
                })
            })
        })
    }
}

function forceUpdate(serviceWorker) {
    const CONFIRM_MESSAGE = localize('updateConfirmation')

    if (confirm(CONFIRM_MESSAGE)) {
        const messageChannel = new MessageChannel()

        messageChannel.port1.addEventListener('message', (event) => {
            console.debug('message received in main thread')
            if (event.data?.command === 'confirmSkipWaiting') {
                console.debug('skip Waiting is confirmed')
                window.location.reload()
            }
        })

        serviceWorker.postMessage(
            { command: 'skipWaiting', message: 'Activate update now' },
            [messageChannel.port2]
        )
    }
}
